<template lang="pug">
  table.transactions_table.table.is-narrow.is-fullwidth.is-striped.is-narrow(v-if='transactions.length')
    thead
      tr
        th
        th(v-if='!HM.is_mobile')
          a(v-if="sort_method.includes('_usd_amount')" @click="sort_method = 'date-desc'")
            | {{ $t('Date') }}
          a(v-if="sort_method == 'date-asc'" @click="sort_method = 'date-desc'")
            | {{ $t('Date') }}
            .icon.is-small: v-icon(name='sort-up')
          a(v-if="sort_method == 'date-desc'" @click="sort_method = 'date-asc'")
            | {{ $t('Date') }}
            .icon.is-small: v-icon(name='sort-down')
        th(v-if='categories.length > 1') {{ $t('Category') }}
        th {{ $t('Description') }}
        th.is-narrow.has-text-right
          a(v-if="sort_method.includes('date')" @click="sort_method = '_usd_amount-asc'")
            | {{ $t('Amount') }}
          a(v-if="sort_method == '_usd_amount-asc'" @click="sort_method = '_usd_amount-desc'")
            | {{ $t('Amount') }}
            .icon.is-small: v-icon(name='sort-up')
          a(v-if="sort_method == '_usd_amount-desc'" @click="sort_method = '_usd_amount-asc'")
            | {{ $t('Amount') }}
            .icon.is-small: v-icon(name='sort-down')
    tbody
      tr(v-for='transaction in sorted_transactions' :key='transaction.id')
        td.is-narrow
          a.button.is-small.row-button(@click='select(transaction)', :id="'transaction-'+transaction.id")
            .icon.is-small: v-icon(name='pencil-alt')
        td.is-narrow(v-if='!HM.is_mobile') {{ transaction.date }}
        td.is-narrow(v-if='categories.length > 1') {{ transaction.fShortCategory() }}
        td {{ transaction.fDescription() }}
        td.has-text-right
          transaction_amount(:transaction="transaction")
</template>

<script>
import 'vue-awesome/icons/pencil-alt'
import 'vue-awesome/icons/sort-down'
import 'vue-awesome/icons/sort-up'

export default {
  name: 'transactions_table',
  components: {
    transaction_amount: require('components/inside/pages/transactions/transaction_amount.vue').default
  },
  data() {
    return {
      sort_method: 'date-desc'
    }
  },
  props: {
    transactions: {
      type: Array,
      required: true
    }
  },
  computed: {
    sorted_transactions() {
      let trs = _.map(this.transactions, function(tr) {
        // need to set temporary attribute to sort by it
        tr._usd_amount = tr.sortable_amount_usd()
        return tr
      })
      return _.orderBy(trs, ...this.sort_method.split('-'))
    },
    categories() {
      return _.uniq(_.map(this.transactions, (tr) => `"${tr.category || '...'}"`)).sort()
    }
  },
  methods: {
    select(transaction) {
      this.$store.dispatch('selectTransaction', transaction)
    }
  }
}
</script>

<style lang="sass">
.transactions_table
  margin-bottom: 0.5rem
  td
    vertical-align: middle
</style>
